const DEFAULT_DEMO_NOW_ISO = '2026-10-13T10:00:00-07:00';

const getEnvMode = () => import.meta.env.MODE || '';
const getDemoFixedNow = () => import.meta.env.VITE_DEMO_FIXED_NOW || '';

export const isDemoClockEnabled = () => {
  return getEnvMode() === 'demo' || Boolean(getDemoFixedNow());
};

export const getDemoNow = () => {
  const iso = getDemoFixedNow() || DEFAULT_DEMO_NOW_ISO;
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return new Date(DEFAULT_DEMO_NOW_ISO);
  return parsed;
};

export const getAppNow = () => (
  isDemoClockEnabled() ? getDemoNow() : new Date()
);

export const getAppTodayStart = () => {
  const today = new Date(getAppNow());
  today.setHours(0, 0, 0, 0);
  return today;
};
